import { useScrollAnimation } from '../../../hooks/useScrollAnimation';

const industries = [
  {
    icon: 'ri-film-line',
    title: 'Entertainment Brands',
    benefit: 'Explosive audience growth. Sellout events. Cultural relevance.',
    tag: 'Entertainment',
    image: 'https://public.readdy.ai/ai/img_res/f35b8f99c5112a7ede7ff81866bb1806.jpg',
  },
  {
    icon: 'ri-car-line',
    title: 'Car Dealerships',
    benefit: 'More test drives. Faster inventory turnover. Record months.',
    tag: 'Automotive',
    image: 'https://readdy.ai/api/search-image?query=luxury%20car%20dealership%20showroom%20at%20night%20with%20gleaming%20sports%20cars%20under%20dramatic%20spotlights%2C%20polished%20floor%20reflections%2C%20dark%20moody%20atmosphere%2C%20cinematic%20automotive%20photography%2C%20deep%20black%20background%20with%20electric%20blue%20accent%20lighting%2C%20ultra%20sharp%20detail&width=400&height=220&seq=ind-auto-01&orientation=landscape',
  },
  {
    icon: 'ri-building-line',
    title: 'Real Estate Agencies',
    benefit: 'Premium listings go viral. Qualified buyers flood in.',
    tag: 'Real Estate',
    image: 'https://readdy.ai/api/search-image?query=modern%20luxury%20real%20estate%20property%20exterior%20at%20dusk%2C%20sleek%20contemporary%20architecture%20with%20large%20glass%20windows%2C%20warm%20interior%20lights%20glowing%2C%20manicured%20landscaping%2C%20dark%20moody%20sky%2C%20premium%20residential%20photography%2C%20deep%20black%20tones%20with%20golden%20warm%20accents&width=400&height=220&seq=ind-realestate-01&orientation=landscape',
  },
  {
    icon: 'ri-scales-line',
    title: 'Law Firms',
    benefit: 'High-value cases from Google and Meta — not just referrals.',
    tag: 'Legal',
    image: 'https://readdy.ai/api/search-image?query=prestigious%20law%20firm%20office%20interior%20with%20dark%20wood%20bookshelves%20filled%20with%20legal%20books%2C%20leather%20chairs%2C%20dramatic%20moody%20lighting%2C%20scales%20of%20justice%20on%20desk%2C%20sophisticated%20dark%20atmosphere%2C%20professional%20legal%20setting%2C%20cinematic%20dark%20tones%20with%20warm%20amber%20accents&width=400&height=220&seq=ind-legal-01&orientation=landscape',
  },
];

export default function Industries() {
  const ref = useScrollAnimation();

  return (
    <section id="industries" className="bg-black py-24 md:py-32">
      <div ref={ref} className="max-w-7xl mx-auto px-6 lg:px-10">
        {/* Header */}
        <div className="mb-16 fade-in-up">
          <p className="text-electric-blue text-xs font-semibold tracking-widest uppercase mb-4">
            Industries We Dominate
          </p>
          <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4">
            <h2 className="font-display font-bold text-white leading-tight max-w-xl"
              style={{ fontSize: 'clamp(2rem, 3.5vw, 3rem)' }}
            >
              We Don't Dabble.<br />We Dominate.
            </h2>
            <p className="text-white/40 text-sm md:text-base max-w-sm leading-relaxed">
              Four verticals. One obsessive focus: making you the undisputed market leader in your category.
            </p>
          </div>
        </div>

        {/* Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {industries.map((ind, i) => (
            <div
              key={ind.title}
              className="fade-in-up group relative bg-dark-card border border-dark-border rounded-lg card-lift cursor-default overflow-hidden flex flex-col"
              style={{ transitionDelay: `${i * 0.1}s` }}
            >
              {/* Top glow on hover */}
              <div className="absolute top-0 left-0 right-0 h-px bg-electric-blue/0 group-hover:bg-electric-blue/40 transition-all duration-500 z-10" />

              {/* Image */}
              <div className="w-full h-40 overflow-hidden flex-shrink-0 relative">
                <img
                  src={ind.image}
                  alt={ind.title}
                  className="w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
                />
                {/* Dark overlay for contrast */}
                <div className="absolute inset-0 bg-gradient-to-b from-black/10 via-black/20 to-black/60" />
                {/* Tag overlaid on image */}
                <span className="absolute bottom-3 left-4 text-xs font-semibold tracking-widest text-white/60 uppercase">
                  {ind.tag}
                </span>
              </div>

              {/* Content */}
              <div className="p-6 flex flex-col flex-1">
                {/* Title */}
                <h3 className="font-display font-semibold text-white text-lg mb-2 group-hover:text-electric-blue transition-colors duration-300">
                  {ind.title}
                </h3>

                {/* Benefit */}
                <p className="text-white/40 text-sm leading-relaxed group-hover:text-white/60 transition-colors duration-300 flex-1">
                  {ind.benefit}
                </p>

                {/* Arrow */}
                <div className="mt-5 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  <i className="ri-arrow-right-line text-electric-blue text-sm" />
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
